<template>
  <exec-report-panel report-name="finance" title="Finanzas y conciliación" :filters="filters" @error="$emit('error', $event)" />
</template>

<script>
import ExecReportPanel from './ExecReportPanel.vue';
// Pestaña 13 · Finanzas y conciliación (doc 04 §3, reporte 12).
export default { name: 'ExecFinance', components: { ExecReportPanel }, props: { filters: { type: Object, default: () => ({}) } } };
</script>
